/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Discard_StayInputs */

const vi_shop_home_discard_stay = /** @type {(inputs: Shop_Home_Discard_StayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ở lại`)
};

/**

* @param {Shop_Home_Discard_StayInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_discard_stay = /** @type {((inputs?: Shop_Home_Discard_StayInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Discard_StayInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_discard_stay(inputs)
});